



import proj4 from 'proj4';
import {register} from 'ol/proj/proj4';
import {get as getProjection} from 'ol/proj';

export  class Projections {

    constructor() {
        this.defaultProjection=getProjection('EPSG:3857');
        //SJTSK
        var prj=getProjection('EPSG:5514');
        var projStr;
        if(!prj ) {
            projStr = '+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222 +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel +pm=greenwich +units=m +no_defs +towgs84=570.8,85.7,462.8,4.998,1.587,5.261,3.56'
            proj4.defs('EPSG:5514', projStr)
            register(proj4);
        }

    }
    getProjectionByEpsg(epsg) {
        //if (epsg==='10267') epsg='5514';
        var prj=getProjection('EPSG:'+epsg);
        if (!prj) prj=this.defaultProjection;

        return  prj;

    }

}
